import React from 'react';
import ReactDOM from 'react-dom';
import RouterComponent from './components/RouterComponent'
import { unregister } from './registerServiceWorker';
import { Provider } from 'react-redux'
import store from './store'
import { OidcProvider } from 'redux-oidc';
import userManager from './utils/userManager';
import "./i18next";

ReactDOM.render(
  <Provider store={store}>
    <OidcProvider store={store} userManager={userManager}>
      <RouterComponent />
    </OidcProvider>
  </Provider>, document.getElementById('root'));

unregister();


// WEBPACK FOOTER //
// ./src/index.js